//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passCesium3DTile = 4.0;\n\
";
